import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import Image from "./images/romanfigure3.png";

const CaseStudiesSection = () => {
  return (
    <Box
      sx={{
        background: {
          xs: `url(${Image}) center bottom no-repeat`,
          md: `url(${Image}) center center no-repeat`,
        },
        backgroundSize: { xs: "-1%", md: "-1%" },
        backgroundPosition: { xs: "center bottom", md: "center" },
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        width: "100%",
        height: "900px",
        color: "#000",
        py: { xs: 4, md: 8 },
        px: { xs: 3, md: 6 },
        textAlign: "center",
      }}
    >
      <Box sx={{ maxWidth: "900px", mx: "auto", mb: 6 }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            mb: 3,
            lineHeight: 1.3,

            fontSize: {
              xs: "2.1rem",
              md: "3.3rem",
              color: "#cc7472",
            },
          }}
        >
          Реальные примеры успеха:
        </Typography>
      </Box>
      <Grid
        container
        spacing={4}
        sx={{
          flexDirection: { xs: "row", md: "column" },
          alignItems: { xs: "stretch", md: "center" },
          justifyContent: { xs: "flex-start", md: "flex-start" },
        }}
      >
        <Grid item xs={12} md={4} sx={{ width: { md: "100%" } }}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              borderRadius: "10px",
              textAlign: "left",
              backgroundColor: {
                xs: "rgba(255, 255, 255, 0.95)",
                md: "rgba(255, 255, 255, 0.95)",
              },
              mb: { md: 4 },
            }}
          >
            <Typography variant="body1" sx={{ fontStyle: "italic", mb: 2 }}>
              “Один из моих клиентов, владелец компании по дизайну интерьеров,
              поднял цены на 20%, сохранил лояльность ключевых клиентов и
              увеличил доход на $25,000 всего за три месяца.”
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4} sx={{ width: { md: "100%" } }}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              borderRadius: "10px",
              textAlign: "left",
              backgroundColor: {
                xs: "rgba(255, 255, 255, 0.95)",
                md: "rgba(255, 255, 255, 0.95)",
              },
              mb: { md: 4 },
            }}
          >
            <Typography variant="body1" sx={{ fontStyle: "italic", mb: 2 }}>
              “Клиент из IT-сферы создал новую бизнес-модель, что позволило
              удвоить команду и привлечь заказчиков из топ-500 мировых
              компаний.”
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4} sx={{ width: { md: "100%" } }}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              borderRadius: "10px",
              textAlign: "left",
              backgroundColor: {
                xs: "rgba(255, 255, 255, 0.95)",
                md: "rgba(255, 255, 255, 0.95)",
              },
            }}
          >
            <Typography variant="body1" sx={{ fontStyle: "italic", mb: 2 }}>
              “Предприниматель из Израиля в сфере элитной недвижимости внедрил
              систему управления проектами, сократил расходы на 15% и расширил
              рынок за счёт новых партнёров.”
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CaseStudiesSection;

// import React from "react";
// import { Box, Typography, Grid, Paper } from "@mui/material";
// import Image from "./images/romanfigure3.png";

// const CaseStudiesSection = () => {
//   return (
//     <Box
//       sx={{
//         background: {
//           xs: `url(${Image}) center bottom no-repeat`,
//           md: `url(${Image}) center center no-repeat`,
//         },
//         backgroundSize: { xs: "-1%", md: "-1%" },
//         backgroundPosition: { xs: "center bottom", md: "center" },
//         backgroundRepeat: "no-repeat",
//         overflow: "hidden",
//         width: "100%",
//         height: "900px",
//         color: "#000",
//         py: { xs: 4, md: 8 },
//         px: { xs: 3, md: 6 },
//         textAlign: "center",
//         marginTop: "80px",
//         marginBottom: "-140px",
//       }}
//     >
//       <Box sx={{ maxWidth: "900px", mx: "auto", mb: 9 }}>
//         <Typography
//           variant="h4"
//           fontWeight="bold"
//           sx={{
//             marginTop: "-40px",
//             lineHeight: 1.3,
//             backgroundColor: "white",
//             fontSize: {
//               xs: "2.1rem",
//               md: "3.3rem",
//               color: "#cc7472",
//             },
//           }}
//         >
//           Реальные примеры успеха:
//         </Typography>
//       </Box>
//       <Grid
//         container
//         spacing={4}
//         sx={{
//           marginTop: "-100px",
//           flexDirection: { xs: "row", md: "column" },
//           alignItems: { xs: "stretch", md: "center" },
//           justifyContent: { xs: "flex-start", md: "flex-start" },
//         }}
//       >
//         <Grid item xs={12} md={4} sx={{ width: { md: "100%" } }}>
//           <Paper
//             elevation={3}
//             sx={{
//               p: 4,
//               borderRadius: "10px",
//               textAlign: "left",
//               backgroundColor: {
//                 xs: "rgba(255, 255, 255, 0.95)",
//                 md: "rgba(255, 255, 255, 0.95)",
//               },
//               mb: { md: 4 },
//             }}
//           >
//             <Typography variant="body1" sx={{ fontStyle: "italic", mb: 2 }}>
//               “Один из моих клиентов, владелец компании по дизайну интерьеров,
//               поднял цены на 20%, сохранил лояльность ключевых клиентов и
//               увеличил доход на $25,000 всего за три месяца.”
//             </Typography>
//           </Paper>
//         </Grid>

//         <Grid item xs={12} md={4} sx={{ width: { md: "100%" } }}>
//           <Paper
//             elevation={3}
//             sx={{
//               p: 4,
//               borderRadius: "10px",
//               textAlign: "left",
//               backgroundColor: {
//                 xs: "rgba(255, 255, 255, 0.95)",
//                 md: "rgba(255, 255, 255, 0.95)",
//               },
//               mb: { md: 4 },
//             }}
//           >
//             <Typography variant="body1" sx={{ fontStyle: "italic", mb: 2 }}>
//               “Клиент из IT-сферы создал новую бизнес-модель, что позволило
//               удвоить команду и привлечь заказчиков из топ-500 мировых
//               компаний.”
//             </Typography>
//           </Paper>
//         </Grid>

//         <Grid item xs={12} md={4} sx={{ width: { md: "100%" } }}>
//           <Paper
//             elevation={3}
//             sx={{
//               p: 4,
//               borderRadius: "10px",
//               textAlign: "left",
//               backgroundColor: {
//                 xs: "rgba(255, 255, 255, 0.95)",
//                 md: "rgba(255, 255, 255, 0.95)",
//               },
//             }}
//           >
//             <Typography variant="body1" sx={{ fontStyle: "italic", mb: 2 }}>
//               “Предприниматель из Израиля в сфере элитной недвижимости внедрил
//               систему управления проектами, сократил расходы на 15% и расширил
//               рынок за счёт новых партнёров.”
//             </Typography>
//           </Paper>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default CaseStudiesSection;
